import { VariableProvider } from '@bpmn-io/variable-resolver';
import { getSchemaVariables } from '@bpmn-io/form-js';
import { getBusinessObject, is } from 'bpmn-js/lib/util/ModelUtil';

/**
 * Variable Provider that parses example JSON from a specific Zeebe property
 */
class FormVariableProvider extends VariableProvider {
  constructor(eventBus, ...rest) {
    super(...rest);

    this._eventBus = eventBus;
  }

  async getVariables(element) {

    /**
     * Use the eventBus to collect form schemas. We currently only support locally defined forms,
     * but plan to have linked forms on a project level soon.
     */
    const formSchema = await this._eventBus.fire('formVariableProvider.getFormSchema', { element });

    if (!formSchema) {
      return;
    }

    let variables;
    try {
      variables = getSchemaVariables(
        JSON.parse(formSchema),
        {
          inputs : false,
          outputs : true
        }
      );
    }
    catch (err) {

      // invalid JSON or schema, ignore error
      return;
    }

    return variables.map(name => {
      return { name, info: `Returned from Form in ${element.name || element.id}` };
    });
  }

  static $inject = [ 'eventBus', ...super.$inject ];
}

function getExtensionElements(element, type) {
  const bo = getBusinessObject(element);

  let elements = [];
  const extensionElements = bo.get('extensionElements');

  if (typeof extensionElements !== 'undefined') {
    const extensionValues = extensionElements.get('values');

    if (typeof extensionValues !== 'undefined') {
      elements = extensionValues.filter(e => is(e, type));
    }
  }

  return elements;
}

/**
 * Subscribe to the eventBus and handle Forms that are defined locally in the
 * Process.
 */
function formExtractor(eventBus) {
  eventBus.on('formVariableProvider.getFormSchema', getLocalForm);
}

formExtractor.$inject = [ 'eventBus' ];

// helpers ////////////

function getLocalForm({ element }) {
  const formDefinition = getExtensionElements(element, 'zeebe:FormDefinition')[0];

  if (!formDefinition) {
    return;
  }

  const formKey = formDefinition.formKey;

  if (!formKey) {
    return;
  }

  const formId = formKey.replace('camunda-forms:bpmn:', '');
  const process = getProcess(element);

  const taskForms = getExtensionElements(process, 'zeebe:UserTaskForm');

  const form = taskForms.find(form => form.id === formId);

  if (!form) {
    return;
  }

  return form.body;
}

function getProcess(element) {
  let parent = element.$parent;

  while (parent && !is(parent, 'bpmn:Process')) {
    parent = parent.$parent;
  }

  return parent;
}

var index = {
  __init__: [
    'formVariableProvider',
    'formVariableProvider.formExtractor'
  ],
  formVariableProvider: [ 'type', FormVariableProvider ],
  'formVariableProvider.formExtractor': [ 'type', formExtractor ]
};

export { index as default };
